import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrimeContractorRoutingModule } from './prime-contractor-routing.module';
import { HomeComponent } from './home/home.component';
import { PrimeContractorComponent } from './prime-contractor.component';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileModule } from '../profile/profile.module';
import { SharedModule } from '../shared/shared.module';
import { SitesComponent } from './sites/sites.component';
import { ViewSiteComponent } from './sites/view-site/view-site.component';
import { JobsComponent } from './jobs/jobs.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { PreviewIncidentReportComponent } from './incidents/preview-incident-report/preview-incident-report.component';
import { PreviewReportComponent } from './jobs/preview-report/preview-report.component';
import { CheckpointScansComponent } from './checkpoint-scans/checkpoint-scans.component';

@NgModule({
  declarations: [
    HomeComponent,
    PrimeContractorComponent,
    SitesComponent,
    ViewSiteComponent,
    JobsComponent,
    IncidentsComponent,
    PreviewIncidentReportComponent,
    PreviewReportComponent,
    CheckpointScansComponent,
  ],
  imports: [
    CommonModule,
    PrimeContractorRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DragDropModule,
    CdkCopyToClipboard,
    ProfileModule,
  ],
})
export class PrimeContractorModule {}
